// ============================================================
// EMERGENCY BODY UNLOCK — runs immediately on every page load
// Clears any stuck body.style from a previous broken modal state
// ============================================================
(function() {
  // Clear any stuck overflow locks on both <html> and <body>
  document.documentElement.style.overflow = '';
  var b = document.body;
  if (b) {
    b.style.overflow = '';
    b.style.position = '';
    b.style.top = '';
    b.style.width = '';
    b.style.left = '';
    b.style.right = '';
  }
})();


// ============================================================
// CAROUSEL SCROLL ENGINE
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  var scrollContainers = document.querySelectorAll('.elite-grid, .hero-studies-row, .timeline-tabs, .founders-grid, .testimonial-track');
  
  scrollContainers.forEach(function(container) {
    container.style.scrollSnapType = 'none';

    var isDown = false;
    var startX, scrollLeft, velocity = 0, lastX = 0, lastTime = 0, rafId = null;

    function snapToNearest() {
      var children = Array.from(container.children);
      if (!children.length) return;
      var bestScroll = container.scrollLeft;
      var minDistance = Infinity;
      var containerPaddingLeft = parseInt(window.getComputedStyle(container).paddingLeft) || 0;
      children.forEach(function(child) {
        var snapAlign = window.getComputedStyle(child).scrollSnapAlign || 'center';
        var targetScroll;
        if (snapAlign.includes('center')) {
          targetScroll = child.offsetLeft + (child.offsetWidth / 2) - (container.clientWidth / 2);
        } else {
          targetScroll = child.offsetLeft - containerPaddingLeft;
        }
        var maxScroll = container.scrollWidth - container.clientWidth;
        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
        var distance = Math.abs(container.scrollLeft - targetScroll);
        if (distance < minDistance) { minDistance = distance; bestScroll = targetScroll; }
      });
      (function animateSnap() {
        var diff = bestScroll - container.scrollLeft;
        if (Math.abs(diff) > 1) {
          container.scrollLeft += diff * 0.15;
          rafId = requestAnimationFrame(animateSnap);
        } else {
          container.scrollLeft = bestScroll;
        }
      })();
    }

    function applyInertia() {
      if (Math.abs(velocity) > 0.8) {
        container.scrollLeft -= velocity;
        velocity *= 0.95;
        rafId = requestAnimationFrame(applyInertia);
      } else {
        snapToNearest();
      }
    }

    container.addEventListener('mousedown', function(e) {
      isDown = true; cancelAnimationFrame(rafId);
      startX = e.pageX; scrollLeft = container.scrollLeft;
      lastX = e.pageX; lastTime = performance.now();
      container.style.cursor = 'grabbing';
    });
    container.addEventListener('mouseleave', function() {
      if (isDown) { isDown = false; container.style.cursor = 'grab'; applyInertia(); }
    });
    container.addEventListener('mouseup', function() {
      isDown = false; container.style.cursor = 'grab'; applyInertia();
    });
    container.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      container.scrollLeft = scrollLeft + (startX - e.pageX);
      var now = performance.now(), dt = now - lastTime;
      if (dt > 0) velocity = (e.pageX - lastX) * (16 / dt);
      lastX = e.pageX; lastTime = now;
    });

    var touchStartY = 0, isHorizontalSwipe = null;
    container.addEventListener('touchstart', function(e) {
      cancelAnimationFrame(rafId);
      startX = e.touches[0].pageX; touchStartY = e.touches[0].pageY;
      scrollLeft = container.scrollLeft;
      lastX = e.touches[0].pageX; lastTime = performance.now();
      velocity = 0; isHorizontalSwipe = null;
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
      var currentX = e.touches[0].pageX, currentY = e.touches[0].pageY;
      var deltaX = Math.abs(currentX - startX), deltaY = Math.abs(currentY - touchStartY);
      if (isHorizontalSwipe === null && (deltaX > 5 || deltaY > 5)) {
        isHorizontalSwipe = deltaX > deltaY;
      }
      if (isHorizontalSwipe === true) {
        if (e.cancelable) e.preventDefault();
        container.scrollLeft = scrollLeft + (startX - currentX);
        var now = performance.now(), dt = now - lastTime;
        if (dt > 0 && dt < 100) velocity = (currentX - lastX) * (16 / dt) * 2.2;
      }
      lastX = currentX; lastTime = performance.now();
    }, { passive: false });

    container.addEventListener('touchend', function() {
      applyInertia();
    });
  });
});
